import { useState } from 'react';
import useInterval from '@use-it/interval';

/**
 * @typedef {Object} CaptureOverlayProps
 * @property {import('../../types/proposal').ClassicOverlay} overlay - Classic overlay with animated frames
 * @property {boolean} [animate] - Whether to cycle through overlay frames
 */

/**
 * Renders a classic (non-fiesta) overlay as an animated or static frame sequence.
 *
 * @param {CaptureOverlayProps} props
 */
const CaptureOverlay = ({ overlay, animate }) => {
  const [overlayFrame, setOverlayFrame] = useState(0);
  const interval = overlay.frameInterval * 1000;

  useInterval(
    () => {
      setOverlayFrame((f) => (f === overlay.frames.length - 1 ? 0 : f + 1));
    },
    overlay && overlay.frames.length > 1 && animate ? interval : null
  );

  return (
    <div className="video-demo__overlay">
      <img alt="" src={overlay.frames[overlayFrame]} />
    </div>
  );
};

export default CaptureOverlay;
